export default __webpack_public_path__ + "static/media/Instagram.718fbe92.svg";